import React, { useState,useEffect } from "react";
import "../SellerUppernav/SellerUppernav.css";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import SellerServicesUrl from "../../SellerServicesUrl";
import { BaseUrl } from "../../App";
import axios from "axios";

export default function SellerUppernav() {
  const [showLogout, setShowLogout] = useState(false);
  const [searchValue, setSearchValue] = useState("");
    const [notificationCount, setNotificationCount] = useState(0);
  
  const navigate = useNavigate();

  const handleSearch = () => {
    const value = searchValue.trim();
    if (!value) {
      navigate("/seller/sellerhome", { replace: true });
      return;
    }
    navigate(`/seller/sellerhome?search=${encodeURIComponent(value)}`, {
      replace: true,
    });
  };

  const handleLogout = () => {
    setShowLogout(false);
    localStorage.removeItem("token");
    localStorage.removeItem("user_token");
    localStorage.removeItem("seller_user");
    localStorage.removeItem("user");
    navigate("/login");
  };
async function getNotificationCount() {
  const token = localStorage.getItem("token");

  //  if (!token) return;
if (!token) {
  setNotificationCount(0);
  return;
}
  try {
    const res = await axios.get(
      BaseUrl + SellerServicesUrl.GetSellerCountNotification,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("🔔 SELLER COUNT:", res.data);

    setNotificationCount(
      res.data?.data?.unread_count || 0
    );

  } catch (err) {
    console.log(
      "❌ SELLER COUNT ERROR:",
      err.response?.data || err.message
    );
  }
}
useEffect(() => {
  getNotificationCount();

  const handler = () => getNotificationCount();

  window.addEventListener("notificationUpdated", handler);

  return () => {
    window.removeEventListener("notificationUpdated", handler);
  };
}, []);
  return (
    <>
      <div className="sellertn-uppernav">
        <div className="sellertn-uppernav-wrapper px-2 px-md-4">
          
          <img src={logo} alt="logo" className="tn-nav-logo" />

          <div className="tn-left-icons">
            {/* <i className="fa fa-bell tn-nav-icon mt-1"></i> */}
              <div
  className="notification-wrapper"
  onClick={() => navigate("/seller/sellernotifications")}
  style={{ cursor: "pointer", position: "relative" }}
>
  <i className="fa fa-bell tn-nav-icon"></i>

  {notificationCount > 0 && (
    <span className="notification-badge">
      {notificationCount}
    </span>
  )}
</div>

            <div
              className="logout-wrapper"
              onClick={() => setShowLogout(true)}
              style={{ cursor: "pointer" }}
            >
    <i
              className="fa fa-user tn-nav-icon pt-3"
              onClick={() => setShowLogout(true)}
            > 
            {/* <span className="logoutuser ">خروج</span> */}
              </i>
            </div>
          </div>

        </div>
      </div>

      {showLogout && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <h3>هل تريد تسجيل الخروج ؟</h3>

            <button
              className="logout-confirm"
              onClick={handleLogout}
            >
              تسجيل الخروج
            </button>

            <button
              className="logout-cancel"
              onClick={() => setShowLogout(false)}
            >
              إلغاء
            </button>

          </div>
        </div>
      )}
    </>
  );
}
